export const coherentIframeStyles = () => ({
    iframe: {
        width: '100%',
        height: '700px',
        border: 0
    },
    actions: {
        display: 'flex',
        justifyContent: 'right',
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        '& button': {
            textTransform: 'none',
            borderRadius: 0,
            borderColor: 'black',
            fontSize: 14,
            marginTop: '5px'
        }
    }
});
